egtoFormGroupState.$inject = [];

export function egtoFormGroupState() {
    var directive = {
        link: link,
        restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs) {
        var states = [
            attrs.egtoFormGroupState + '.$dirty',
            attrs.egtoFormGroupState + '.$touched',
            attrs.egtoFormGroupState + '.$invalid'
        ];

        scope.$watchGroup(states, function(newValues) {
            var dirty = newValues[0];
            var touched = newValues[1];
            var invalid = newValues[2];
            if(dirty && touched && invalid){
                element.addClass('has-error');
                element.removeClass('has-success');
            } else if(dirty && touched){
                element.addClass('has-success');
                element.removeClass('has-error');
            } else {
                element.removeClass('has-success');
                element.removeClass('has-error');
            }
        });
    }
}